export const BASE_URL = process.env.REACT_APP_BASE_URL;

export const getAgeInterval = (ages: number[]): string => {
  const uniqueAges = Array.from(new Set(ages)).sort((a, b) => a - b);
  if (uniqueAges.length === 0) return '';
  if (uniqueAges.length === 14 && uniqueAges[0] === 0 && uniqueAges[13] === 13) {
    return 'Tüm Yaşlar';
  }
  const min = uniqueAges[0];
  const max = uniqueAges[uniqueAges.length - 1];
  if (min === max) return max === 13 ? '12+ Yaş' : `${min} Yaş`;
  return max === 13 ? `${min}-12+ Yaş` : `${min}-${max} Yaş`;
};

export const timeMapping = [
  { value: 100, name: '24 saat açık' },
  { value: 12, name: '06:00' },
  { value: 13, name: '06:30' },
  { value: 14, name: '07:00' },
  { value: 15, name: '07:30' },
  { value: 16, name: '08:00' },
  { value: 17, name: '08:30' },
  { value: 18, name: '09:00' },
  { value: 19, name: '09:30' },
  { value: 20, name: '10:00' },
  { value: 21, name: '10:30' },
  { value: 22, name: '11:00' },
  { value: 23, name: '11:30' },
  { value: 24, name: '12:00' },
  { value: 25, name: '12:30' },
  { value: 26, name: '13:00' },
  { value: 27, name: '13:30' },
  { value: 28, name: '14:00' },
  { value: 29, name: '14:30' },
  { value: 30, name: '15:00' },
  { value: 31, name: '15:30' },
  { value: 32, name: '16:00' },
  { value: 33, name: '16:30' },
  { value: 34, name: '17:00' },
  { value: 35, name: '17:30' },
  { value: 36, name: '18:00' },
  { value: 37, name: '18:30' },
  { value: 38, name: '19:00' },
  { value: 39, name: '19:30' },
  { value: 40, name: '20:00' },
  { value: 41, name: '20:30' },
  { value: 42, name: '21:00' },
  { value: 43, name: '21:30' },
  { value: 44, name: '22:00' },
  { value: 45, name: '22:30' },
  { value: 46, name: '23:00' },
  { value: 47, name: '23:30' },
  { value: 0, name: '00:00' },
];

export const getTime = (time: number) =>
  timeMapping.find((interval) => interval.value === time)?.name;

export const ALL_DAY_DURATION = 1000;

export const formatDuration = (duration: number): string => {
  if (duration === ALL_DAY_DURATION) return 'Tüm gün';
  if (duration % 60 === 0 && duration >= 120) return `${duration / 60} saat`;
  return `${duration} dk`;
};

export const AGE_RANGES = [
  { label: '0 Yaş', value: 0 },
  { label: '1 Yaş', value: 1 },
  { label: '2 Yaş', value: 2 },
  { label: '3 Yaş', value: 3 },
  { label: '4 Yaş', value: 4 },
  { label: '5 Yaş', value: 5 },
  { label: '6 Yaş', value: 6 },
  { label: '7 Yaş', value: 7 },
  { label: '8 Yaş', value: 8 },
  { label: '9 Yaş', value: 9 },
  { label: '10 Yaş', value: 10 },
  { label: '11 Yaş', value: 11 },
  { label: '12 Yaş', value: 12 },
  { label: '12+ Yaş', value: 13 },
];
